(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("pageForm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/customPages/pageFormView.html",
            controller: ["connectionsResource", "pagesResource", "messageService", "REG_EXP", "$filter", "$http", "$localStorage", "$location", "$q", "$rootScope", "$state", "$stateParams", "$translate", "$uibModal", "_", PageFormCtrl],
            controllerAs: "vm"
        };
        function PageFormCtrl(connectionsResource, pagesResource, messageService, REG_EXP, $filter, $http, $localStorage, $location, $q, $rootScope, $state, $stateParams, $translate, $uibModal, _) {
            var vm = this;
            vm.showErrors = false;
            vm.model = angular.copy($stateParams);
            vm.model.isPublic = true;
            vm.loading = true;
            vm.friendlyUrlPattern = REG_EXP.friendlyUrl;
            vm.pageNamePattern = REG_EXP.pageName;
            vm.tenantUrl = location.origin + "/pages";
            vm.disqusEnabled = false;
            var lang = $translate.proposedLanguage() || $translate.use();
            var languageCulture = lang;
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 500,
                plugins: "autoresize, code, wordcount, paste, image, preview, template",
                plugin_preview_height: 700,
                plugin_preview_width: 980,
                language: lang,
                convert_urls: 0,
                paste_data_images: true,
                inline_styles: true,
                extended_valid_elements: "style,link[href|rel|type],script[src]",
                valid_children: "+a[div|p|h2]",
                custom_elements: "style,link,~link,script",
                templates: [
                    {
                        title: $translate.instant("settings.customPages.template1.title"),
                        description: $translate.instant("settings.customPages.template1.description"),
                        url: "/templates/pages/home1.html"
                    }
                ],
                file_browser_callback: function (field_name) {
                    var modal = $uibModal.open({
                        templateUrl: "/app/modals/customPages/customPageMediaBrowserView.html",
                        animation: false,
                        controller: "CustomPageMediaBrowserCtrl as vm",
                        size: "lg",
                        backdrop: "static",
                        backdropClass: "over-mce-modal-backdrop",
                        windowClass: "over-mce-modal",
                        resolve: {
                            languageCulture: function () {
                                return languageCulture;
                            },
                            pageName: function () {
                                return vm.model.name;
                            },
                            enabledLocalizations: function () {
                                return vm.model.enabledLocalizations;
                            },
                            localizationId: function () {
                                return vm.selectedLocalizationId;
                            }
                        }
                    });
                    modal.result.then(function (url) {
                        angular.element("#" + field_name).val(url);
                    }).catch(angular.noop);
                },
                images_upload_handler: function (blobInfo, success) {
                    var formData = new FormData();
                    formData.append("file", blobInfo.blob(), blobInfo.filename());
                    $http.post("api/pageFiles/" + languageCulture + "/" + vm.model.name, formData, { transformRequest: angular.identity, headers: { 'Content-Type': undefined } })
                        .then(function (response) {
                        success(response.data.value);
                        messageService.success("common.fileUploaded");
                    }, function (errorData) {
                        messageService.error(errorData);
                    });
                },
                selector: "textarea"
            };
            vm.cancel = function () {
                $state.go("main.settings.customPages");
            };
            connectionsResource.isDisqusEnabled(function (result) {
                vm.isDisqusEnabled = result.value;
            });
            if ($state.current.name === "main.settings.customPagesAddPage") {
                vm.state = "Add";
                vm.pageTitle = "menu.customPages.addPage";
                vm.model = {
                    friendlyUrl: "",
                    isHomePage: false
                };
                vm.loading = false;
            }
            else {
                vm.state = "Edit";
                vm.pageTitle = "menu.customPages.editPage";
                pagesResource.getPageDetail({ id: $stateParams.id }, function (result) {
                    vm.dataFriendlyUrl = angular.copy(result.friendlyUrl);
                    vm.dataName = angular.copy(result.name);
                    angular.extend(vm.model, result);
                    vm.indexPosition = result.pageContents.indexOf(result.pageContents[0]);
                    vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                    vm.pageContent = angular.copy(_.where(result.pageContents, { localizationId: vm.selectedLocalizationId })[0]);
                    checkDetails();
                    copyOriginalDetail();
                    vm.loading = false;
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }
            vm.saveGeneral = function () {
                if (vm.saving)
                    return;
                if (vm.generalPageForm.$valid) {
                    vm.saving = true;
                    checkFriendlyUrl();
                    if (vm.state === "Add") {
                        pagesResource.save({}, vm.model, function (data) {
                            messageService.success("settings.customPages.pageForm.pageSaved");
                            $state.go("main.settings.customPagesEditPage", { id: data.id });
                            $rootScope.$broadcast("reloadTenantSettings");
                            vm.saving = false;
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                    else {
                        pagesResource.updatePage({ id: vm.model.id }, vm.model, function () {
                            messageService.success("settings.customPages.pageForm.generalPageInfoSaved");
                            $rootScope.$broadcast("reloadTenantSettings");
                            vm.saving = false;
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.saveAndReturnGeneral = function () {
                vm.saveGeneral();
                $state.go("main.settings.customPages");
            };
            vm.saveContent = function (redirect) {
                if (vm.savingContent)
                    return;
                if (vm.form.$valid) {
                    vm.savingContent = true;
                    angular.extend(vm.pageContent, $stateParams);
                    vm.pageContent.localizationId = vm.selectedLocalizationId;
                    vm.pageContent.pageId = $stateParams.id;
                    pagesResource.savePageDetail(vm.pageContent, function (result) {
                        angular.extend(vm.model, result);
                        vm.indexPosition = result.pageContents.indexOf(result.pageContents[0]);
                        vm.pageContent = angular.copy(_.where(result.pageContents, { localizationId: vm.selectedLocalizationId })[0]);
                        copyOriginalDetail();
                        vm.savingContent = false;
                        messageService.success("settings.customPages.pageForm.pageContentSaved");
                        $rootScope.$broadcast("reloadTenantSettings");
                        if (redirect)
                            $state.go("main.settings.customPages");
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.changeLocalization = function (localizationId, langCulture) {
                if (vm.selectedLocalizationId !== localizationId) {
                    if (!angular.equals(vm.pageContentOriginal, vm.pageContent)) {
                        var modal = $uibModal.open({
                            templateUrl: "unSavedDataWillBeLost.html",
                            backdrop: false,
                            animation: false,
                            windowClass: "confirmation-modal",
                            controller: ["$scope", function ($scope) {
                                    var unSavedChangesVm = this;
                                    unSavedChangesVm.dontSave = function () {
                                        changeLanguage(localizationId, langCulture);
                                        $scope.$dismiss();
                                    };
                                }],
                            controllerAs: "unSavedChangesVm"
                        });
                        modal.result.then(function () {
                            vm.saveContent(false);
                            changeLanguage(localizationId, langCulture);
                        }, function () {
                            $("#" + vm.selectedLocalizationId).focus();
                        });
                    }
                    else {
                        changeLanguage(localizationId, langCulture);
                    }
                }
            };
            function changeLanguage(localizationId, langCulture) {
                languageCulture = langCulture;
                vm.selectedLocalizationId = localizationId;
                vm.pageContent = angular.copy(_.where(vm.model.pageContents, { localizationId: localizationId })[0]);
                checkDetails();
                copyOriginalDetail();
                vm.indexPosition = vm.model.pageContents.indexOf(vm.selectedDetailLocalization);
            }
            function copyOriginalDetail() {
                vm.pageContentOriginal = angular.copy(vm.pageContent);
            }
            function checkDetails() {
                if (!vm.pageContent)
                    vm.pageContent = { name: null, content: null, isPublished: false };
            }
            function checkFriendlyUrl() {
                if (!vm.model.friendlyUrl)
                    vm.model.friendlyUrl = $filter("slugify")(vm.model.name);
            }
            vm.fillFriendlyUrl = function () {
                if (vm.model.name) {
                    checkFriendlyUrl();
                }
            };
            vm.checkFriendlyUrlIsAvailable = function (url) {
                return $q(function (resolve, reject) {
                    if (url === vm.dataFriendlyUrl)
                        resolve(true);
                    else {
                        pagesResource.isFriendlyUrlAvailable({ url: url }, function (result) {
                            if (result.value)
                                resolve(true);
                            else
                                reject();
                        });
                    }
                });
            };
            vm.checkPageNameIsAvailable = function (name) {
                return $q(function (resolve, reject) {
                    if (name) {
                        if ($filter("lowercase")(name) === $filter("lowercase")(vm.dataName))
                            resolve(true);
                        else {
                            pagesResource.isPageNameAvailable({ name: name }, function (result) {
                                if (result.value)
                                    resolve(true);
                                else
                                    reject();
                            });
                        }
                    }
                });
            };
        }
    });
}());
